"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDash = void 0;
var react_1 = __importStar(require("react"));
var UserDash = function (_a) {
    var name = _a.name, photo = _a.photo, children = _a.children, open = _a.open, setOpen = _a.setOpen, _b = _a.customClasses, customClasses = _b === void 0 ? '' : _b, _c = _a.fallbackImagePath, fallbackImagePath = _c === void 0 ? '/profile-grey.png' : _c;
    var node = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', closeMenu);
        return function () {
            document.removeEventListener('mousedown', closeMenu);
        };
    }, []);
    var openMenu = function () {
        setOpen(!open);
    };
    var closeMenu = (0, react_1.useCallback)(function (e) {
        var _a;
        if (!((_a = node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            setOpen(false);
        }
    }, []);
    return (react_1.default.createElement("div", { ref: node, className: "axxes-header__topbar__user axxes-custom-dropdown ".concat(customClasses), onClick: openMenu },
        react_1.default.createElement("span", null, name),
        react_1.default.createElement("div", { className: "axxes-header__topbar__user__img-container" },
            react_1.default.createElement("img", { src: photo, alt: 'userPhoto', onError: function (e) {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = fallbackImagePath;
                } })),
        react_1.default.createElement("ul", { className: "axxes-custom-dropdown__list ".concat(open && '-open') }, children)));
};
exports.UserDash = UserDash;
